import { PROCEDURE_TYPE_DISPLAY } from "./procedureTypeDisplay";
import { ProcedureType } from "./search/utils/constants";

const CHAPTER_CHIP_TEXT_COLOR = "#fff";

const isChapter = (chapter) =>
  chapter !== null && typeof chapter === "object" && typeof chapter.name === "string";

const hasChapterDisplay = (chapter) => isChapter(chapter) && Boolean(chapter.shortName || chapter.color);

const procedureTypeColor = (procedureType) =>
  (PROCEDURE_TYPE_DISPLAY[procedureType] ?? PROCEDURE_TYPE_DISPLAY[ProcedureType.IMAGING]).sx.bgcolor;

/**
 * Chip label and style for a practice: its chapter's alias and color when the chapter
 * has an alias or a color loaded, otherwise the procedureType chip ("Prácticas"/"Laboratorio").
 * A chapter without alias nor color, or one that isn't an object (a saved order item's
 * chapter name, null, missing), shows the procedureType chip.
 *
 * @param {{ chapter?: { name: string, shortName?: string|null, color?: string|null }|string|null, procedureType?: string|null }} item
 * @returns {{ label: string, sx: object }|null} null when there's nothing to show
 */
export const chapterChipFor = ({ chapter, procedureType }) => {
  if (!hasChapterDisplay(chapter)) return PROCEDURE_TYPE_DISPLAY[procedureType] ?? null;
  return {
    label: chapter.shortName || chapter.name,
    sx: {
      bgcolor: chapter.color || procedureTypeColor(procedureType),
      color: CHAPTER_CHIP_TEXT_COLOR,
    },
  };
};
